export class CompanyEntity {
  name: string;
  logo: string;
  unSelectedLogo: string;
  id: number;
  checked?: boolean;

  constructor(companyEntity: object) {
    Object.assign(this, companyEntity);
  }
}
